import { SearchSaleAnalytics } from './SearchSaleAnalytics'
import { withSearchSaleAnalytics } from './withSearchSaleAnalytics'

const ConnectedSearchSaleAnalytics =
  withSearchSaleAnalytics(SearchSaleAnalytics)

export { ConnectedSearchSaleAnalytics as SearchSaleAnalytics }
